<template>
  <div class="blk_address_map">
    <div class="wrap_map" :class="{wide: wide}">
      <iframe :src="iframeSrc" width="375" height="390" :title="mapTitle" frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>
    <p class="access_address">
      〒{{ addressNum }}<br>{{ address }}
    </p>
    <p class="map_link"><a :href="mapLink">Google Mapで見る &gt;</a></p>
    <div class="wrap_btn"><a :href="appBoostLink" class="btn btn_radius btn_map btn_arrow_r icon-">地図アプリで見る</a></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AddressMap',
  props: {
    msg: String,
    wide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ]),
    mapTitle () {
      return `${this.siteData.info.clinic_name}の地図`
    },
    iframeSrc () {
      return this.siteData.info.iframe
    },
    mapLink () {
      return this.siteData.info.map_link
    },
    appBoostLink () {
      const link = this.siteData.info.map_link
      const regExp = new RegExp('/@[0-9a-zA-Z.,]+/')
      const replaceRg = new RegExp('[/@]', 'ig')
      const points = regExp.exec(link)[0].replace(replaceRg, '').split(',')
      const path = `https://maps.google.com/maps?q=${points[0]},${points[1]}+${this.siteData.info.clinic_name}`
      return path
    },
    address () {
      return this.siteData.info.address
    },
    addressNum () {
      return this.siteData.info.address_number
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
